import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ParentWindowMessagingService} from '../../shared/services/parent-window-messaging.service';

export type ForceReloginReason = 'EMAIL_PASSWORD_ADDED' | 'EMAIL_CHANGED' | 'PASSWORD_CHANGED';

export interface ForceReloginDialogData {
  reason: ForceReloginReason;
  emailVerificationRequired: boolean;
  email?: string;
}

export const MSG_EMAIL_PASSWORD_ADDED = $localize`:@@section.signInMethods.msg.emailPasswordAdded:The email and password have been added successfully.`;

@Component({
  selector: 'app-force-relogin-dialog',
  templateUrl: './force-relogin-dialog.component.html',
  styleUrls: ['./force-relogin-dialog.component.scss'],
})
export class ForceReloginDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: ForceReloginDialogData,
    private readonly dialogRef: MatDialogRef<ForceReloginDialogComponent>,
    private readonly parentWindowMessaging: ParentWindowMessagingService,
  ) {}

  get successMessage(): string {
    switch (this.data.reason) {
      case 'EMAIL_PASSWORD_ADDED':
        return MSG_EMAIL_PASSWORD_ADDED;
      case 'EMAIL_CHANGED':
        return $localize`:@@section.signInMethods.forceRelogin.success.emailChanged:Great, your email has been updated.`;
      case 'PASSWORD_CHANGED':
        return $localize`:@@section.signInMethods.forceRelogin.success.passwordChanged:Great, your password has been updated.`;
    }
  }

  onContinue(): void {
    this.parentWindowMessaging.sendLogin(this.data.email);
    this.dialogRef.close();
  }
}
